export default __webpack_public_path__ + "static/media/androidTv.81988502.png";